/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PlanningLocationType {
    Location = 0,
    Equipment = 1,
    Virtual = 2,
}
